import * as t from "io-ts";
import { createClientCargoTemplateTypes, isoDateTime } from "dora-contracts";
import * as tPromise from "io-ts-promise";

export const {
  createClientCargoTemplateReqT,
  createClientCargoTemplateResT,
  editClientCargoTemplateReqT,
  getClientCargoTemplateResT,
} = createClientCargoTemplateTypes({
  decimal: t.string,
  date: t.string,
  dateTime: isoDateTime,
});

export const decodeClientCargoTemplate = tPromise.decode(
  getClientCargoTemplateResT
);
